var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "storeSetup" }, [
    _c("div", { staticClass: "storename" }, [
      _c("div", { staticClass: "name" }, [_vm._v(_vm._s(_vm.storename))]),
      _vm._v(" "),
      _c("div", { staticClass: "rightgo" }, [
        _c("div", { staticClass: "directSend" }, [
          _vm._v(_vm._s(_vm.storetype))
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "state" }, [
      _c("div", { staticClass: "currenttype" }, [
        _vm._v("状态：" + _vm._s(_vm.currenttype))
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d8a626be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8a626be","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/basic/storeSetup.vue
// module id = null
// module chunks = 